import React, { useState } from "react";
import { motion } from "framer-motion";

const About = () => {
  const [resumeUrl, setResumeUrl] = useState(
    "https://drive.google.com/file/d/15RM6BxqeXbCQeS0mlQBS3NHyW0LFdtxD/view?usp=sharing"
  );

  return (
    <motion.div
      className="About"
      id="About"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}>
      {/* Heading */}
      <motion.div
        className="aboutHeading"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.3 }}>
        About
      </motion.div>

      {/* Content Section */}
      <motion.div
        className="aboutContent"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.5 }}>
        <motion.p
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.6 }}>
          I often <span className="red">wonder</span> why I chose to become an
          engineer instead of a scientist. Then I realized:{" "}
          <span className="red">
            "A scientist discovers new types of materials or energy, while an
            engineer finds new uses for them."
          </span>
        </motion.p>
        <br></br>
        <motion.p
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.7 }}>
          Hello, this is Surya Pratap Singh. I'm currently pursuing my engineering
          degree in Computer Science from{" "}
          <u>
            <a href="https://iiitp.ac.in/" target="_blank">
              Indian Institute Of Information Technology Pune.
            </a>
          </u>
          <br />I am a Computer Science Engineer and a Full-Stack Developer.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.8 }}>
          Two of my greatest passions are psychology and engineering: while one
          illuminates the intricacies of the world, the other empowers us to
          change it.
        </motion.p>

        {/* List with Staggered Effects */}
        <br></br>
        <motion.ul
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.3 },
            },
          }}>
          {[
            "Pursuing B.Tech at IIIT Pune (2022-2026) with a current CGPA of 8.65",
            "Completed Class 12th from Dr. Rizvi Springfield School with 95% in the CBSE board",
            "Completed Class 10th from Dr. Rizvi Springfield School with 94% in the CBSE board",
          ].map((item, index) => (
            <motion.li
              key={index}
              variants={{
                hidden: { opacity: 0, x: -20 },
                visible: { opacity: 1, x: 0 },
              }}
              transition={{ duration: 1 }}>
              {item}
            </motion.li>
          ))}
        </motion.ul>

        {/* Resume Download Button */}
        <motion.span
          className="resumebtn"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 1 }}>
          <a href={resumeUrl} download>
            <motion.span
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.3 }}>
              Download My Resume
            </motion.span>
          </a>
        </motion.span>
      </motion.div>
    </motion.div>
  );
};

export default About;
